import React, { useEffect, useState } from "react";
import Tooltip from "../../../Components/Tooltip";
import LeftMap from "../../../Components/Map/cityProfileMap";
import RightMap from "../../../Components/Map/cityProfileMap";
import { BoxTitle, checkFalsyValues } from "./Overview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useApi from "../../../Hooks/useApi";
import LoadingSpinner from "../../Shared/LoadingSpinner";
import { NoDataBox } from "../../UI/Charts/NoDataFoundMessage";

const ToolsAndVehiclesGrid = ({ title, info, itemsColor, isComparison }) => {
  const isEmpty = !Array.isArray(info) || info.length === 0;
  return (
    <div className="grid grid-cols-1 xl:grid-cols-[auto,1fr] gap-5">
      <p
        className={`
 title-text-size text-[#2F4B7C]
    ${
      isComparison
        ? "w-full col-span-full text-start"
        : "text-left xl:border-e min-w-[200px] lg:min-w-[300px] xl:min-w-[400px] 2xl:min-w-[500px] break-words"
    }
  `}
      >
        {title}
      </p>
      <div
        className={`${
          isEmpty
            ? "col-span-full grid place-items-center w-full"
            : "grid grid-cols-2 lg:grid-cols-4 gap-4 text-start"
        }`}
      >
        {!isEmpty ? (
          info?.map((item, index) => (
            <div
              key={index}
              className="flex gap-3"
              style={{ color: itemsColor }}
            >
              {item.icon && (
                <FontAwesomeIcon
                  icon={item.icon}
                  size="sm"
                  className="text-lg mt-1"
                />
              )}
              <div className="flex flex-col">
                <p className="title-text-size">{item.indicator}</p>
                <p className="font-semibold text-lg">{item.value}</p>
              </div>
            </div>
          ))
        ) : (
          <NoDataBox className="py-4" />
        )}
      </div>
    </div>
  );
};

const Infrastructure = ({ isComparison, firstCity, secondCity }) => {
const { request, loading: loadingFirst } = useApi({ isPublic: true });
  const { request: requestSecond, loading: loadingSecond } = useApi({
    isPublic: true,
  });

  const [firstCityInfra, setFirstCityInfra] = useState();
  const [secondCityInfra, setSecondCityInfra] = useState();

  const getInfrastructureData = async (city, year, setter, req) => {
    try {
      const response = await req(
        "GET",
        `/v1/city-profile/infrastructure?location=${city}&year=${year}`,
        {},
        "survey_service",
      );

      setter(checkFalsyValues(response));
    } catch (error) {
      console.error("Failed to fetch infrastructure data:", error);
    }
  };

  useEffect(() => {
    if (firstCity?.city && firstCity?.year) {
      getInfrastructureData(
        firstCity.city.id,
        firstCity.year,
        setFirstCityInfra,
        request,
      );
    } else {
      setFirstCityInfra();
    }
  }, [firstCity?.city, firstCity?.year, request]);

  useEffect(() => {
    if (isComparison && secondCity?.city && secondCity?.year) {
      getInfrastructureData(
        secondCity.city.id,
        secondCity.year,
        setSecondCityInfra,
        requestSecond,
      );
    } else {
      setSecondCityInfra();
    }
  }, [secondCity?.city, secondCity?.year, isComparison, requestSecond]);

  const renderGrid = (title, color) => {
    if (
      !isComparison &&
      (!firstCityInfra?.[title] || firstCityInfra[title].length === 0)
    )
      return null;

    return (
      <>
        <ToolsAndVehiclesGrid
          title={title}
          info={firstCityInfra?.[title] || []}
          itemsColor={color}
          isComparison={isComparison}
        />
        {isComparison && (
          <ToolsAndVehiclesGrid
            title={title}
            info={secondCityInfra?.[title] || []}
            itemsColor={color}
            isComparison={isComparison}
          />
        )}
      </>
    );
  };
  const isLoading = loadingFirst || (isComparison && loadingSecond);
  if (isLoading)  return <LoadingSpinner message="Loading Infrastructure Data..." />;
  
const toolsGrid = renderGrid("Tools used by Conservancy Department", "#2F4B7C");
const vehiclesGrid = renderGrid("Vehicles used in SWM", "#FFA600");
const showMap = !(!isComparison && !firstCity?.dataSource);

if (!isComparison && !toolsGrid && !vehiclesGrid && !showMap) return null;

return (
  <div className="border border-[#2F4B7C] border-opacity-30 p-5" id="Infrastructure">
    <BoxTitle title="Infrastructure" />

    <div className="space-y-10">
      {toolsGrid && (
        <div className={`w-full grid ${isComparison ? "md:grid-cols-2 gap-10" : "grid-cols-1"}`}>
          {toolsGrid}
        </div>
      )}

      {vehiclesGrid && (
        <div className={`w-full grid ${isComparison ? "md:grid-cols-2 gap-10" : "grid-cols-1"}`}>
          {vehiclesGrid}
        </div>
      )}

      {showMap && (
        <div className="space-y-5">
          <p className="text-[#2F4B7C] text-center md:text-start">
            <Tooltip id={"FSM"}>FSM</Tooltip> &
            <Tooltip id={"SWM"}>SWM</Tooltip> Infrastructure Map
          </p>
          <div className="flex gap-4 w-full flex-col lg:flex-row">
            <div className="w-full h-full">
              <LeftMap city={firstCity} />
            </div>
            {isComparison && (
              <div className="w-full h-full">
                <RightMap city={secondCity} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  </div>
);
};

export default Infrastructure;
